import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 16px;

  p {
    a {
      color: ${getColor('textLink')};
      text-decoration: underline;
    }
  }

  .most-popular-module {
    padding: 0 16px;

    .hero-eyebrow, h3 {
      text-align: left;
    }
  }

   @media (${breakpoint.mdMin}) {
    padding: 0 0;
   }

  @media (${breakpoint.lgMin}) {
    gap: 48px;

    .most-popular-module {
      padding: 0 24px;
    }
  }

  &.franchise-content {
    .breadcrumbs {
      margin-bottom: -30px;

      li:last-child {
        margin-left: 0;

        &:after {
          display: none;
        }
      }
    }
  }
`;

export const Header = styled(Heading)`
  margin-bottom: 8px;
  @media (${breakpoint.mdMin}) {
        min-width: 280px;
    }
`;

export const TickerWrapper = styled.div`
    min-height: 126px;
  @media (${breakpoint.mdMin}) {
    min-width: 280px;
  }
`;

export const TabsContainer = styled.div<{ theme: Theme }>`
  background-color: ${getColor('neutralWhite')};
  padding: 24px;

  .tabs {
    .half-width {
      max-width: 532px;
      margin-left: auto;
      margin-right: auto;
      padding-top: 24px;
    }
  }

  @media (${breakpoint.lgMin}) {
    padding: 40px;
  }
`;

export const AccordionsContainer = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  background-color: ${getColor('neutralWhite')};
`;

export const Container = styled.div<{ theme: Theme }>`
  &:empty {
    display: none;
  }
  display: flex;
  flex-direction: column;
  gap: 40px;

  .latest-module {
    padding: 0 16px;
    h3 {
      text-align: left;
    }
  }

  .stock-chart {
    padding: 0 16px;
  }

  @media (${breakpoint.mdMin}) {
    .stock-chart {
      padding: 0 8px;
    }

    .latest-module {
      padding: 0 16px;
    }
  }

  @media (${breakpoint.lgMin}) {
    flex-direction: row;
    gap: 48px;

    .latest-module {
      padding: 0 40px;
      
      &.no-padding {
        padding: 0;
      }
    }
    
    .stock-chart {
      padding: 0 0 0 40px;
    }
  }

  &.introContainer {
    background-color: ${getColor('neutralWhite')};
    padding: 24px 16px;
    justify-content: space-between;
    align-items: flex-start;

    @media (${breakpoint.mdMin}) {
      padding: 40px;

      & > * {
        flex: 1 auto;
      }
    }
  }
`;

export const GridContainer = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  background-color: ${getColor('neutralWhite')};
  padding: 24px 16px;

  .accordions .accordion-wrapper {
    gap: 0;
    margin-top: 24px;

    &:first-of-type {
      margin-top: 0;
    }
  }

  .accordions .ranking-list.content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    &:first-of-type {
      a:first-child {
        margin-top:24px;
      }
    }
  }

  @media (${breakpoint.smMin}) {
      .accordions {
          margin-top: 12px;
      }     
  }
    
  @media (${breakpoint.lgMin}) {
    display: grid;
    grid-template-columns: fit-content(100%) 1fr;
    align-items: flex-start;
    padding: 40px;
    row-gap: 32px;

    .tabs, .accordions {
      grid-column: 1 / 3;
    }
  }
`;

export const NativoWrapper = styled.div`
  padding: 0 16px;

  @media (${breakpoint.lgMin}) {
    padding: 0 40px;
  }

  .nativo-company {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
    width: 1346px;

    @media (${breakpoint.lgMin}) {
      padding: 0 48px;
    }
  }

  div.nativo-ads {
    display: grid;
    padding-top: 16px;
    gap: 32px;

    @media (${breakpoint.mdMin}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (${breakpoint.lgMin}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;

export const SectionWrapper = styled.div<{ $gap: number }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.$gap}px;
  padding: 0 16px;
  margin-bottom: -24px;

  @media (${breakpoint.mdMin}) {
    padding: 0 16px;
  }

  @media (${breakpoint.lgMin}) {
    padding: 0 40px;
  }
`;

export const VideoContainer = styled.div`
  display: grid;
  gap: 40px;
  align-items: center;
  padding: 24px 16px;

  @media (${breakpoint.lgMin}) {
    grid-template-columns: 2fr 1fr;
    padding: 40px;
    gap: 48px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 12px;
  height: 269px;
  
  &:empty {
    display: none;
  }
`;
